function ClearableInputsDirective($, $log) {
	return {
		restrict: 'A',
		link(scope, element) {

			function toggle(condition) {
				return condition ? 'addClass' : 'removeClass';
			}

			function clearInput(evt) {
				const inputPosition = this.getBoundingClientRect();
				try {
					const clearBtn = {
						Xmin: inputPosition.right - 50,
						Xmax: inputPosition.right
					};

					const clickX = evt.originalEvent.pageX || evt.originalEvent.targetTouches[0].clientX;
					if (clickX > clearBtn.Xmin && clickX < clearBtn.Xmax && this.tagName !== 'TEXTAREA') {
						evt.preventDefault();
						$(this).removeClass('input--clear-icon input--clear-icon-active').val('').change();
					}
				} catch (e) {
					$log.log('e');
				}
			}

			function showCursor(evt) {
				const appendClear = this.offsetWidth - 45 < evt.clientX - this.getBoundingClientRect().left;
				$(this)[toggle(appendClear)]('input--clear-icon-active');
			}

			function showX() {
				return $(this)[toggle(this.value)]('input--clear-icon');
			}

			$(element).on('input', '.input--clear', showX)
				.on('mousemove', '.input--clear-icon', showCursor)
				.on('touchstart click', '.input--clear-icon', clearInput);
		}
	};
}

module.exports = ClearableInputsDirective;



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/clearable-inputs/clearable-inputs-directive.js
 **/